import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top whenever the route pathname changes.
// Fixes perceived "link does nothing" when user is scrolled down a list
// and clicks a card — the new page renders but old scroll position is kept.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}
